import {
    VisualModalComponent
} from "../../../../../components/visual/modal/VisualModalComponent";
import {OfferPricingComponent} from "../pricing/OfferPricingComponent";
import {IOfferDetailsModel} from "../../../../../../models/offer/IOfferDetailsModel";
import {Resources} from "../../../../../../resources/Resources";
import {ICommunityModel} from "../../../../../../models/community/ICommunityModel";
import {Network} from "../../../../../../network/Network";
import {OfferService} from "../../../../../../services/offer/OfferService";
import {AccountLogType} from "../../../../../../models/account/log/AccountLogType";

export class OfferModalComponent extends VisualModalComponent {

    public offerComponent: OfferPricingComponent;

    constructor(details?: IOfferDetailsModel, community?: ICommunityModel, website?: boolean, source?: string) {
        super("raw");
        if (!website) {
            OfferService.track(AccountLogType.OFFER_MODAL_OPEN, source ?? window.location.pathname);
        }
        this.modalStyle = `width:${community ? `100%` : `1400px`};height: calc(100% - 40px) !important;max-width: calc(100% - 60px);`
        this.name = Resources.t("words.offerPricing");

        this.offerComponent = new OfferPricingComponent(details, community, website);
        this.offerComponent.onCloseModal = () => this.close();
        this.offerComponent.onRendered = () => this.timeOut(() => this.resize(), 50);
        this.offerComponent.onSignup = () => this.onSignup();
        this.modalTemplate = this.draw(this.offerComponent);
    }

    onSignup() {
        Network.router.pages.redirect(Network.router.pages.getPanelUrl("signup"), true);
    }

}
